import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { getJwt } from '@/shared/lib/betterAuth/get-jwt'
import { getPetClaimList } from '@/services/claims.services'
import {
  CLAIMS_QUERY_KEYS,
  CACHE_STALE_TIME,
  CACHE_GC_TIME,
  QUERY_NETWORK_MODE,
} from '@/shared/constants/cache'
import type {
  PetClaimList,
  PetClaimListKind,
} from '@/shared/types/global.types'

export function usePetClaimList(
  kind: PetClaimListKind,
  policyIds: string[],
  page: number,
  perPage: number,
) {
  const { i18n } = useTranslation()

  return useQuery<PetClaimList>({
    queryKey: CLAIMS_QUERY_KEYS.petList(kind, page),
    enabled: policyIds.length > 0,
    queryFn: async () => {
      const token = await getJwt()
      if (!token) throw new Error('No JWT token')
      return getPetClaimList(
        token,
        i18n.language,
        kind,
        policyIds,
        page,
        perPage,
      )
    },
    // Keeps the current page on screen while the next one loads
    placeholderData: keepPreviousData,
    staleTime: CACHE_STALE_TIME,
    gcTime: CACHE_GC_TIME,
    networkMode: QUERY_NETWORK_MODE,
  })
}
